export default "__VITE_ASSET__ZMgLCg3r__";